import { createAction } from 'redux-actions'

export const setRelatedArticles = createAction('ARTICLE_DETAIL/SET_RELATED_ARTICLES')
